import { EnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Provides the application with Onetrust, the cookie consent manager used by all Genesys web properties
 * @returns app initializer provider
 */
export const provideOnetrustCookieManager = (): EnvironmentProviders =>
    provideAppInitializer(() => {
        const initializerFn = onetrustInitializer();
        return initializerFn();
    });

export function onetrustInitializer(): () => Promise<void> {
    return async () => {
        await new Promise<void>((resolve, _) => {
            if (environment.production == true) {
                const script = document.createElement('script');
                script.async = true;
                script.id = 'lvlzer0';
                script.setAttribute('data-gtm', 'true');
                script.setAttribute('data-gdprcm', 'true');
                script.setAttribute('data-gtm_id', 'GTM-TKNR763');
                script.src = 'https://web-fire.genesys.com/lvlzer0/lvlzer0.min.js';

                script.onerror = () => {
                    console.debug('[Injectors][OneTrustInjector] Error while injecting.');
                    resolve(); // The script may have been blocked by an ad blocker
                };

                script.onload = () => {
                    console.debug('[Injectors][OneTrustInjector] Successfully injected.');
                    resolve();
                };

                document.head.appendChild(script);
            } else {
                console.debug('[Injectors][OneTrustInjector] Skipping Onetrust due to non-production environment');
                resolve();
            }
        });
    };
}
